import { useTranslation } from "react-i18next";

function StatusBadge({ color, title }) {
  const { t } = useTranslation("general");

  return <div className={`c-status-badge ${color}`}>{t(title)}</div>;
}

export default StatusBadge;
